<template>
  <div v-if="isBurger" class="nav-burger">
    <button
      class="nav-burger__button-toggle"
      :aria-expanded="isOpen"
      aria-controls="#nav-burger-content"
      @click="toggle"
    >
      <svg
        aria-hidden="true"
        class="nav-burger__icon"
        :class="{ 'nav-burger__icon--is-open': isOpen }"
        width="48px"
        height="48px"
        viewBox="0 0 48 48"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <line
            x1="2"
            y1="17"
            x2="46"
            y2="17"
            stroke-width="4"
            stroke-linecap="round"
          />
          <line
            x1="2"
            y1="31"
            x2="46"
            y2="31"
            stroke-width="4"
            stroke-linecap="round"
          />
        </g>

        <g>
          <line
            x1="0"
            y1="24"
            x2="48"
            y2="24"
            stroke-width="4"
            stroke-linecap="round"
          />
          <line
            x1="0"
            y1="24"
            x2="48"
            y2="24"
            stroke-width="4"
            stroke-linecap="round"
          />
        </g>
      </svg>
      <a-label :path="isOpen ? 'closeBurgerMenu' : 'openBurgerMenu'" />
    </button>
    <teleport to="#nav-burger-target">
      <div v-if="isOpen" class="nav-burger__content" id="nav-burger-content">
        <slot name="inline-search" />
        <slot name="nav-expandable" />
        <slot name="logo-list" />
        <slot name="nav-meta" />
        <slot name="socialmedia-links" />
      </div>
    </teleport>
  </div>
  <template v-else>
    <slot name="nav-meta" />
    <slot name="socialmedia-links" />
    <slot name="nav-expandable" />
    <slot name="search-toggle" />
  </template>
</template>

<script>
import { useStore } from 'vuex';
import { ref, computed, watch, inject } from 'vue';

export default {
  compatConfig: {
    ATTR_FALSE_VALUE: false,
  },

  setup() {
    const store = useStore();
    const isBurger = computed(() => {
      return !store.getters['window/breakpointUp']('navigation');
    });
    const isOpen = ref(false);

    const toggle = () => {
      isOpen.value = !isOpen.value;
    };

    watch(isBurger, isBurger => {
      if (!isBurger) isOpen.value = false;
    });

    const addHeaderClass = inject('header/addClass');
    const removeHeaderClass = inject('header/removeClass');
    const isHeaderFixed = inject('header/isFixed');

    watch(isOpen, isOpen => {
      const html = document.querySelector('html');
      html.classList[isOpen ? 'add' : 'remove']('is-locked-by-dpc-nav-burger');
      (isOpen ? addHeaderClass : removeHeaderClass)('header--has-open-burger');
      if (isOpen && !isHeaderFixed.value) html.scrollTop = 0;
    });

    return { isBurger, isOpen, toggle };
  },
};
</script>
